import { render, staticRenderFns } from "./MainHeader.vue?vue&type=template&id=4f11bcd6&scoped=true&"
import script from "./MainHeader.vue?vue&type=script&lang=js&"
export * from "./MainHeader.vue?vue&type=script&lang=js&"
import style0 from "./MainHeader.vue?vue&type=style&index=0&id=4f11bcd6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f11bcd6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/vhosts/dostartu.pl/app.startzone.online/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4f11bcd6')) {
      api.createRecord('4f11bcd6', component.options)
    } else {
      api.reload('4f11bcd6', component.options)
    }
    module.hot.accept("./MainHeader.vue?vue&type=template&id=4f11bcd6&scoped=true&", function () {
      api.rerender('4f11bcd6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/MainHeader.vue"
export default component.exports